/* =========================================================================================
  File Name: i18n.js
  Description: Thiết lập localize
  ----------------------------------------------------------------------------------------
  Author: PDKIEN
  Author URL: https://misa.com.vn
==========================================================================================*/
import {createI18n} from 'vue-i18n';
import i18nData from './i18nData';

const i18n = createI18n({
  locale: 'vi', // set default locale
  messages: i18nData,
  legacy: false,
});
export default i18n;
